<template>
  <div class="content-view">
    <b-modal
      v-model="showSubmitDeclarationModal"
    >
      Czy na pewno chcesz złożyć tę deklarację? Tej czynności nie da się cofnąć.

      <p v-if="declarationToSubmitType === 'A'">
        Pamiętaj! Jeżeli w budynku znajduje się lokal lub lokale niemieszkalne ogrzewane źródłem ciepła nieuwzględnionym w niniejszej deklaracji, złóż również deklarację B.
      </p>

      <p v-if="declarationToSubmitType === 'B'">
        Pamiętaj! Jeżeli w budynku znajduje się lokal lub lokale mieszkalne ogrzewane źródłem ciepła nieuwzględnionym w niniejszej deklaracji, złóż także deklarację A.
      </p>

      <template #modal-footer="{ ok, cancel }">
        <b-button class="btn btn-primary" @click="submitDeclaration()">
          Tak, złóż
        </b-button>
        <b-button @click="cancel()">
          Cofnij
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showDeleteDeclarationModal"
    >
      Czy na pewno chcesz usunąć tę deklarację? Tej czynności nie da się cofnąć.

      <template #modal-footer="{ ok, cancel }">
        <b-button class="btn btn-primary" @click="deleteDeclaration()">
          Tak, usuń
        </b-button>
        <b-button @click="cancel()">
          Cofnij
        </b-button>
      </template>
    </b-modal>

    <b-navbar type="dark" variant="dark">
      <b-navbar-nav>
        <b-nav-form>
          <model-list-select :list="buildingsFormatted"
                     v-model="filters.buildingId"
                     option-value="value"
                     option-text="text"
                     class="m-md-2"
                     placeholder="Adres budynku">
          </model-list-select>
          <b-button variant="default" class="resetbtn" @click="clearBuildingSearch"><b-icon-x-circle /></b-button>

          <b-dropdown :text="`Typ deklaracji: ${filterDicts.type[filters.type]}`" class="m-md-2">
            <b-dropdown-item @click="filters.type = 'ALL'">Wszystkie</b-dropdown-item>
            <b-dropdown-item @click="filters.type = 'A'">Typ A</b-dropdown-item>
            <b-dropdown-item @click="filters.type = 'B'">Typ B</b-dropdown-item>
          </b-dropdown>

          <b-dropdown :text="`Status deklaracji: ${filterDicts.status[filters.status]}`" class="m-md-2">
            <b-dropdown-item @click="filters.status = 'ALL'">Wszystkie</b-dropdown-item>
            <b-dropdown-item @click="filters.status = 'DRAFT'">Wersja robocza</b-dropdown-item>
            <b-dropdown-item @click="filters.status = 'SUBMITTED'">Złożona</b-dropdown-item>
          </b-dropdown>

          <model-list-select :list="filterDicts.cities"
                     v-model="filters.cityId"
                     option-value="id"
                     option-text="name"
                     class="m-md-2"
                     placeholder="Wybierz miejscowość">
          </model-list-select>

          <b-button variant="default" class="resetbtn" @click="clearCitySearch"><b-icon-x-circle /></b-button>

          <b-form-input
            :disabled="filters.cityId == -1"
            class="m-md-2"
            v-model="filters.address"
            placeholder="Wpisz adres" style="max-width: 80%"></b-form-input>
          <b-button variant="default" class="resetbtn" @click="clearAddressSearch"><b-icon-x-circle /></b-button>

        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>

    <div class="container-fluid table-container">
      <div class="row">
        <div class="col-12">
          <div class="text-center pt-5" v-if="!declarationsLoaded">
            <b-spinner label="Wczytuję"></b-spinner>
            <p>Wczytuję listę deklaracji</p>
          </div>
          <ByBuildingList
            @submit-declaration="showSubmitModal"
            @delete-declaration="showDeleteModal"
            :declarations="declarations"
            v-if="declarationsLoaded"
          />
        </div>
      </div>

      <div class="row" v-if="declarationsLoaded">
        <div class="col-12 text-center mb-5">
          <p v-if="!hasNext">Wyświetlono wszystkie deklaracje o wybranych parametrach</p>
          <b-button v-else @click="getNextPage">Załaduj Kolejne Deklaracje</b-button>
        </div>
      </div>

    </div>

    <building-modal v-if="showBuildingsModal"/>
  </div>
</template>

<script>
import DeclarationsModel from "@/models/declarations";
import ByBuildingList from "@/components/declarationList/ByBuildingList";
import LocationsModel from "@/models/locations";
import BuildingModal from "@/components/buildings/BuildingModal";
import _ from "lodash";
import axios from "axios";

import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  name: "Declarations",
  components: {ByBuildingList, DeclarationsModel, ModelListSelect, BuildingModal},
  data() {
    return {
      showSubmitDeclarationModal: false,
      showDeleteDeclarationModal: false,
      declarationToSubmitId: null,
      declarationToSubmitType: null,
      declarationToDeleteId: null,
      page: 1,
      hasNext: false,
      declarations: [],
      declarationsLoaded: false,
      buildings: [],
      filters: {
        type: "ALL",
        status: "ALL",
        buildingId: "",
        cityId: -1,
        address: ""
      },
      filterDicts: {
        type: {
          "ALL": "Wszystkie",
          "A": "A",
          "B": "B",
        },
        status: {
          "ALL": "Wszystkie",
          "SUBMITTED": "Złożona",
          "DRAFT": "Wersja robocza",
        },
        cities: [],
      }
    }
  },
  methods: {
    submitDeclaration: _.debounce(function () {
      DeclarationsModel.submitDeclaration(this.declarationToSubmitId)
        .then((res) => {
          if (res.data.status === "ok") {
            this.declarations = [];
            this.page = 1;
            this.getDeclarations();
            this.declarationToSubmitId = null;
            this.showSubmitDeclarationModal = false;
            this.$notify({
              group: 'zone',
              type: 'success',
              title: 'Sukces',
              text: 'Pomyślnie złożono deklarację'
            });
          }
        });
    }, 500),
    deleteDeclaration() {
      DeclarationsModel.deleteDeclaration(this.declarationToDeleteId)
        .then((res) => {
          if (res.data.status === "ok") {
            this.declarations = [];
            this.page = 1;
            this.getDeclarations();
            this.declarationToDeleteId = null;
            this.showDeleteDeclarationModal = false;
            this.$notify({
              group: 'zone',
              type: 'success',
              title: 'Sukces',
              text: 'Pomyślnie usunięto deklarację'
            });
          }
        });
    },
    showSubmitModal(data) {
      if (!data.hasStatement) {
        this.$notify({
          group: 'zone',
          type: 'error',
          title: 'Błąd',
          text: 'Aby złożyć deklarację, zaznacz pole z oświadczeniem.'
        });
        return;
      }
      this.declarationToSubmitId = data.declarationId;
      this.declarationToSubmitType = data.declarationType;
      this.showSubmitDeclarationModal = true;
    },
    showDeleteModal(declarationId) {
      this.declarationToDeleteId = declarationId;
      this.showDeleteDeclarationModal = true;
    },
    getNextPage() {
      this.page++;
      this.getDeclarations();
    },
    getDeclarations() {
      this.declarationsLoaded = false;
      DeclarationsModel.getUserDeclarations({...this.filters, page: this.page})
        .then((res) => {
          this.declarations.push(...res.data.results);
          this.hasNext = !!res.data.next;
          this.declarationsLoaded = true;
        });
    },
    getBuildings() {
      LocationsModel.getUserBuildings()
        .then((res) => this.buildings = res.data);
    },
    clearBuildingSearch() {
      this.filters.buildingId = "";
    },
    getCities() {
      return axios.get(`/api/locations/cities`)
        .then((res) => {
          this.filterDicts.cities = res.data;
        })
    },
    clearCitySearch() {
      this.filters.address = "";
      this.filters.cityId = -1;
    },
    clearAddressSearch() {
      this.filters.address = "";
    },
    performAddressSearch: _.debounce(function() {
        this.declarations = [];
        this.page = 1;
        this.getDeclarations();
    }, 250)
  },
  mounted() {
    this.getDeclarations();
    this.getBuildings();
    this.getCities();
  },

  watch: {
    "filters.type": function () {
      this.declarations = [];
      this.page = 1;
      this.getDeclarations();
    },
    "filters.status": function () {
      this.declarations = [];
      this.page = 1;
      this.getDeclarations();
    },
    "filters.buildingId"() {
      this.declarations = [];
      this.page = 1;
      this.getDeclarations();
    },
    "filters.cityId": function () {
      this.page = 1;
      this.declarations = [];
      this.getDeclarations();
    },
    "filters.address": function () {
      this.performAddressSearch();
    },
    declarationsListTrigger(newValue) {
      this.declarations = [];
      this.page = 1;
      this.getDeclarations();
    }
  },

  computed: {
    selectedBuilding() {
      if (this.filters.buildingId) {
        return this.buildings.filter((el) => el.id === this.filters.buildingId)[0].formatted_address;
      }
      return "Wszystkie";
    },
    selectedCity() {
      if (this.filters.cityId === -1) {
        return "Wszystkie";
      }
      return this.filterDicts.cities.filter((el) => el.id === this.filters.cityId)[0].name;
    },
    declarationsListTrigger() {
      return this.$store.state.declarationsListTrigger;
    },
    buildingsFormatted() {
      let result = [{value: "", text: 'Proszę Wybrać Adres Budynku...'}];
      this.buildings.forEach((building) => {
        result.push({
          value: building.id,
          text: building.formatted_address
        });
      })
      return result;
    },
    showBuildingsModal() {
      return this.$store.state.showBuildingsModal;
    }
  }
}
</script>

<style scoped>
.navbar {
  width: 100%;
  z-index: 2;
  color: #FFFFFF;
}

.table-container {
}

.ui.fluid.dropdown {
  width: auto;
  min-width: 20em;
}

.resetbtn {
  color: #FFFFFF;
  padding: 0;
}

@media screen and (max-width: 768px) {
  .navbar {
  }

  .navbar .custom-select, .navbar .dropdown {
    margin-bottom: 0.2rem;
  }

  .table-container {
  }
}

</style>
